@if (noResultPreview) {
    <div
        [ngClass]="{
            'site-search--side-nav': !isTopNavSearch,
            'd-nav-none': isDesktop === false && isTopNavSearch,
        }"
        class="site-search">
        <core-search-v2
            [customIcon]="customIcon"
            [customCloseIcon]="customCloseIcon"
            [closeButtonSize]="closeButtonSize"
            (searchSubmitted)="closeMobileMenu(true)"></core-search-v2>
    </div>
} @else {
    <div
        [ngClass]="{
            'site-search--side-nav': !isTopNavSearch,
            'd-nav-none': isDesktop === false && isTopNavSearch,
        }"
        class="site-search">
        <!-- If isSearchButtonIcon === true (set in search.component.html on <core-search> selector):
     btn--search-icon overrides default .btn styles as only the magnifying glass icon is used as the button to trigger the search modal. -->
        @if (isSearchButtonIcon) {
            <button
                (click)="openModal(template)"
                [core-analytics]="{ action: 'Mini search', category: 'SEARCH' }"
                class="btn btn--search-icon"
                aria-label="Search"
                type="button">
                <!-- Use dedicated icon color so it contrasts with the actual header background, not nav bg -->
                <core-icon name="icon-search" color="var(--color-nav-icon)"></core-icon>
            </button>
        } @else {
            <!-- If isSearchButtonIcon === false (set in search.component.html on <core-search> selector):
       btn--search class will style the search button as a dummy input field. Upon clicking, this opens the search modal. -->
            <button
                (click)="openModal(template)"
                [core-analytics]="{ action: 'Search', category: 'SEARCH' }"
                [innerText]="'Search' | translate"
                class="btn btn--search"
                type="button"></button>
        }
    </div>

    <ng-template #template>
        <core-client-search-form [autoFocus]="true"></core-client-search-form>

        <div class="modal-body">
            <core-client-search-results
                (closeHamburgerNav)="closeMobileMenu($event)"
                [modalRef]="modalRef"></core-client-search-results>
        </div>
    </ng-template>
}
